import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['cover', 'embed'];

  connect() {
    this.videoId = this.element.dataset.youtubeId;
    this.player = null;
    this._boundInitPlayer = this.initPlayer.bind(this);
    this.init();
  }

  disconnect() {
    if (this.player && this.player.destroy) {
      this.player.destroy();
      this.player = null;
    }
    // Clean up the global callback if it points to this instance
    if (window.onYouTubeIframeAPIReady === this._boundInitPlayer) {
      window.onYouTubeIframeAPIReady = undefined;
    }
  }

  init() {
    if (!this.hasEmbedTarget) return;
    // If API is loaded, always initialize the player
    if (window.YT && window.YT.Player) {
      this.initPlayer();
      return;
    }
    // If API is not loaded, set a unique callback for this instance
    // Only set the callback if not already set to this instance
    if (window.onYouTubeIframeAPIReady !== this._boundInitPlayer) {
      window.onYouTubeIframeAPIReady = this._boundInitPlayer;
    }
    // Only append the script if it doesn't already exist
    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
    }
  }

  initPlayer() {
    if (!this.hasEmbedTarget) return;
    // Remove any existing iframe
    this.embedTarget.innerHTML = '';
    // Create a new div for the player
    const playerDiv = document.createElement('div');
    playerDiv.id = `youtube-player-${this.videoId}`;
    this.embedTarget.appendChild(playerDiv);
    this.player = new window.YT.Player(playerDiv.id, {
      videoId: this.videoId,
    });
  }

  play() {
    if (this.hasCoverTarget) {
      this.coverTarget.classList.add('hidden');
    }
    if (this.hasEmbedTarget) {
      this.embedTarget.classList.remove('hidden');
      if (this.player && this.player.playVideo) {
        this.player.playVideo();
      }
    }
  }
}
